/**
 * searchNav.js
 * File for search box in main navigation
 */
/**
 * Document .ready();
 */
jQuery(document).ready(function($) {

    /**
     * Search navigation
     */
    $(document).click(function(e){
        var searchinput = $(".search-box input");
        if (!searchinput.is(e.target) && searchinput.has(e.target).length === 0 && !searchinput.is(":focus")){
            $(".nav-search").removeClass('open');
        } else {
            $('.nav-search').addClass("open");
        }
    }); 
    $('.search-box input').focus(function(){
        $('.nav-search').addClass("open");
    }); 

});